module.exports = __webpack_public_path__ + "img/freelancer-hiring-2.c433ccda.png";